import { Modal } from "antd";

export const success = (title, content) => {
  Modal.success({
    title: title,
    content: content,
    onOk() {
      // setData([]);
    },
  });
};

export const warning = (title, content) => {
  Modal.warning({
    title: title,
    content: content,
    onOk() {
      // setData([]);
    },
  });
};
